import { defineComponent, h, useAttrs } from 'vue'
import { VOverlay } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

VOverlay.compatConfig = {
  ...(VOverlay.compatConfig || {}),
  COMPONENT_V_MODEL: false,
  INSTANCE_ATTRS_CLASS_STYLE: false
}

function normalizeModelValue(value) {
  if (value === false || value === 'false' || value == null) return false
  if (value === '' || value === true || value === 'true') return true
  return Boolean(value)
}

function normalizeBooleanProp(value) {
  if (value === false || value === 'false' || value == null) return undefined
  if (value === '' || value === true || value === 'true') return true
  return value
}

function normalizeAttrs(attrs, props) {
  const normalized = { ...attrs }

  if (props.modelValue !== undefined) {
    normalized.modelValue = normalizeModelValue(props.modelValue)
  } else if (props.value !== undefined) {
    normalized.modelValue = normalizeModelValue(props.value)
  } else if (normalized.modelValue == null && attrs.value !== undefined) {
    normalized.modelValue = normalizeModelValue(attrs.value)
  } else if (normalized.modelValue !== undefined) {
    normalized.modelValue = normalizeModelValue(normalized.modelValue)
  }

  if (normalized.contentClass == null && attrs['content-class'] != null) {
    normalized.contentClass = attrs['content-class']
  }
  if (normalized.maxWidth == null && attrs['max-width'] != null) {
    normalized.maxWidth = attrs['max-width']
  }

  if (
    hasBooleanishAttr(attrs['hide-overlay']) ||
    hasBooleanishAttr(attrs.hideOverlay)
  ) {
    normalized.scrim = false
  }

  normalized.persistent = normalizeBooleanProp(normalized.persistent)

  delete normalized.value
  delete normalized['content-class']
  delete normalized['max-width']
  delete normalized['hide-overlay']
  delete normalized.hideOverlay

  return normalized
}

export default defineComponent({
  name: 'VDialogCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [Boolean, String],
      default: undefined
    },
    value: {
      type: [Boolean, String],
      default: undefined
    }
  },
  emits: ['update:modelValue', 'input'],

  setup(props, { emit, slots }) {
    const attrs = useAttrs()

    return () => {
      const normalizedAttrs = normalizeAttrs(attrs, props)

      return h(
        VOverlay,
        {
          location: normalizedAttrs.location ?? 'center center',
          origin: normalizedAttrs.origin ?? 'center center',
          scrollStrategy: normalizedAttrs.scrollStrategy ?? 'block',
          zIndex: normalizedAttrs.zIndex ?? 2400,
          role: 'dialog',
          ...normalizedAttrs,
          scrim: normalizedAttrs.scrim !== false,
          class: ['v-dialog', normalizedAttrs.class],
          'onUpdate:modelValue': (value) => {
            emit('update:modelValue', value)
            emit('input', value)
          }
        },
        slots
      )
    }
  }
})
